/* tslint:disable:indent */
import {takeUntil} from 'rxjs/operators';
import {PreferencesService} from './../../../preferences-avis-de-pub/services/preferences.service';
import {PreferenceType} from './../../../../shared/models/enum/preferenceType';
import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TypeFacturation} from '../../../../formulaires/common/models/type.facturation';
import {FacturationMessage} from '../../../../shared/models/component-messages/facturation/facturation';
import {CanNavigateInStepperService} from '../../../../shared/services/can-navigate-in-stepper.service';
import {StepperBuilderService} from '../../services/stepper.builder.service';
import {AnnonceurService} from '../../../../formulaires/common/services/annonceur/annonceur.service';
import {LogService} from '../../../../shared/services/log.service';
import {BehaviorSubject, Subject} from 'rxjs';
import { Annonceur } from '../../../../formulaires/common/models/annonceur.pwd';

@Component({
  selector: 'app-id-annonceur',
  templateUrl: './id-annonceur.component.html'
})
export class IdAnnonceurComponent implements OnInit, OnDestroy {

  private LOG: LogService = new LogService(IdAnnonceurComponent);

  private unsubscribe$ = new Subject<void>();

  @Input() form: FormGroup;
  @Input() indexPage: number;

  public facturationMessage = new FacturationMessage();
  @Input() facturation: TypeFacturation;
  @Input() isBOAMPorJOUE: boolean;
  @Input() isSHALorPS: boolean;

  chargePref = false;

  public annonceur: Annonceur = new Annonceur();

  public typeAnnonceur = PreferenceType.ANNONCEUR;

  constructor(public canNavigateInStepperService: CanNavigateInStepperService,
              private stepperBuilderService: StepperBuilderService,
              private annonceurService: AnnonceurService,
              private preferencesService: PreferencesService
  ) {
  }


  ngOnInit(): void {
    if (this.facturation === undefined || this.facturation === null) {
      this.facturation = new TypeFacturation();
    }
    if (this.annonceur === undefined || this.annonceur === null) {
      this.annonceur = new Annonceur();
    }
    this.LOG.debug('[MERGE-FACT][FORM-IdAnnonceurComponent]');
    this.annonceurService.annonceurBhs.subscribe(data => {
      this.annonceur = data;
    });

  }

  getIsCheckValid(stepId) {
    return this.stepperBuilderService.getIsCheckValidate(stepId);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getUid() {
    return '_SepSep_idAnnonceur';
  }

  // TODO
  getUidAnn() {
    return '';
  }

  getForm(str: string) {
    const form = this.stepperBuilderService.formulaire?.toString().includes(str);
    this.chargeDonneePreference();
    return form;
  }

  getIsBOAMPorJOUE() {
    return (this.isBOAMPorJOUE && this.canNavigateInStepperService.isBOAMPorJOUE === null) ||
      (this.canNavigateInStepperService.isBOAMPorJOUE !== null && this.canNavigateInStepperService.isBOAMPorJOUE);
  }

  getIsSHALorPS() {
    return (this.isSHALorPS && this.canNavigateInStepperService.isSHALorPS === null) ||
      (this.canNavigateInStepperService.isSHALorPS !== null && this.canNavigateInStepperService.isSHALorPS);
  }

  chargeDonneePreference() {
    if (!this.chargePref && this.form?.get(this.getUid() + '_SepAtt_idannonceurboampweb') != null) {
      this.chargePref = true;
      this.preferencesService.getFullAnnonceur()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: (data) => {
            if (data.length > 0) {
              data[0].content.values.forEach(el => {
                this.form.get(this.getUid() + '_SepAtt_' + el.code)?.setValue(el.value);
                this.form.get(this.getUid() + '_SepAtt_' + el.code)?.markAsTouched();
              });
            }
          }
        });
    }
  }
}
